import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ESvgIcons } from '../../../../../core/enums/svg-icons';
import { SafeUrlPipe } from '../../../../../shared/pipes/safe-url.pipe';
import { CityProviders } from '../../../../../core/utils/city-services';
import { GetFavoritesByProvider } from '../../../../user-account/user-wish-list-page/measure-amount-of-favorites.pipe';

@Component({
    selector: 'app-wish-preview-card-mobile',
    templateUrl: './wish-preview-card-mobile.component.html',
    styleUrls: ['wish-preview-card-mobile.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgxSkeletonLoaderModule, GetFavoritesByProvider, SafeUrlPipe]
})
export class WishPreviewCardMobileComponent {
  @Input() isFetching: boolean = false;
  @Input() wish: any;

  protected readonly eSvgIcons = ESvgIcons;
  protected readonly placeProvider = CityProviders;
}
